import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

const EMPTY_UPLOAD_STATS_7D = {
  bars: [],
  typeCount: { image: 0, video: 0 },
  healthRate: { success: 0, failed: 0 },
  total: 0,
  ok: 0,
  bad: 0,
};

export async function getAdminDashboard() {
  try {
    const path = `${BACKEND_URL}/admin/get_dashboard`;

    const res = await authFetch(
      path,
      { method: "GET" },
      { refreshUrlIncludes: "auth/refresh" },
    );

    let result = null;
    try {
      result = await res.json();
    } catch {
      result = null;
    }

    if (!res.ok || result?.success !== true) {
      return {
        success: false,
        message: result?.message || "관리자 대시보드 조회 실패",
        kpis: [],
        activities: [],
        uploadStats7d: EMPTY_UPLOAD_STATS_7D,
      };
    }

    const data = result?.data ?? {};

    const kpis = [
      {
        title: "전체 프로젝트 개수",
        value: [data.total_project_count] ?? ["0"],
        tone: "orange",
        momPct: data.project_pct_change_30d,
        inc30d: data.project_new_30d,
        date: "30일",
        linkTo: "projects",
      },
      {
        title: "전체 파일 개수",
        value: [data.total_file_count] ?? ["0"],
        tone: "green",
        momPct: data.file_pct_change_30d,
        inc30d: data.file_new_30d,
        date: "30일",
        linkTo: "files",
      },
      {
        title: "전체 유저 수",
        value: [data.total_user_count] ?? ["0"],
        tone: "blue",
        inc30d: data.user_new_30d, // 최근 30일 증가량(신규), string(콤마 포함)
        date: "30일",
        linkTo: "users",
      },
      {
        title: "발생 오류",
        value: [data.total_error_count] ?? ["0"],
        tone: "red",
        label: "24시간",
        linkTo: null,
      },
    ];

    return {
      success: true,
      message: result?.message || "관리자 대시보드 데이터를 불러왔습니다.",
      total_user_count: data.total_user_count, // 전체 사용자 누적 수(포맷 적용: 콤마 포함 문자열)
      total_project_count: data.total_project_count, // 전체 프로젝트 누적 수(포맷 적용: 콤마 포함 문자열)
      total_file_count: data.total_file_count, // 전체 파일/업로드 누적 수(포맷 적용: 콤마 포함 문자열)
      total_error_count: data.total_error_count, // 전체 에러/실패 누적 수(포맷 적용: 콤마 포함 문자열)
      user_new_30d: data.user_new_30d, // 최근 30일 신규 사용자 수(포맷 적용: 콤마 포함 문자열)
      user_pct_change_30d: data.user_pct_change_30d, // 전월대비(직전 30일 대비) 사용자 증감율(%) - 숫자 또는 null(직전30=0)
      project_new_30d: data.project_new_30d, // 최근 30일 신규 프로젝트 수(포맷 적용: 콤마 포함 문자열)
      project_pct_change_30d: data.project_pct_change_30d, // 전월대비(직전 30일 대비) 프로젝트 증감율(%) - 숫자 또는 null
      file_new_30d: data.file_new_30d, // 최근 30일 신규 파일/업로드 수(upload_history 기준, is_corrupted=0)(포맷 적용: 콤마 포함 문자열)
      file_pct_change_30d: data.file_pct_change_30d, // 전월대비(직전 30일 대비) 파일/업로드 증감율(%) - 숫자 또는 null
      activities: Array.isArray(data?.activities) ? data.activities : [], // 최근 활동 목록 (log + user JOIN, 최신순 N개)
      uploadStats7d:
        typeof data?.uploadStats7d === "object" && data.uploadStats7d
          ? data.uploadStats7d
          : EMPTY_UPLOAD_STATS_7D, // 최근 7일 업로드 통계(KST 기준): bars, typeCount, facilityCount 등
      kpis,
    };
  } catch (error) {
    return {
      success: false,
      message: error?.message || "네트워크 오류가 발생했습니다.",
      kpis: [],
      activities: [],
      uploadStats7d: EMPTY_UPLOAD_STATS_7D,
    };
  }
}
